import { render, staticRenderFns } from "./TeamCreate.vue?vue&type=template&id=322a4241&scoped=true&"
import script from "./TeamCreate.vue?vue&type=script&lang=js&"
export * from "./TeamCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322a4241",
  null
  
)

export default component.exports